'use client';
import './style.sass';

import React from 'react';
import {
    listPageResults,
    listPath,
    listResults,
    listSolutions,
    listSolutionsAnaliz,
    listSolutionsDifficulties,
    listSolutionsMedia,
    listSolutionsMediaParagraf,
    listSolutionsPages,
    listSolutionsParagraf,
    listStages,
    listTitle,
} from '../sk10/constans';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import TitleCase from '../../case-components/title-case';
import Target from '../reusable-components/layouts-component__sk10/target';
import LayoutPage from '../reusable-components/layouts-component__sk10/layout-page';
import Solution from '../reusable-components/layouts-component__sk10/solution';
import Media from '../reusable-components/layouts-component__sk10/media';
import Testing from '../reusable-components/layouts-component__sk10/testing';
import Results from '../reusable-components/layouts-component__sk10/results';
import Team from '../reusable-components/layouts-component__sk10/team';
const nextProjectdevRec = {
    nextProjectTitle: 'Создали платформу для национального конкурса по&nbsp;ИИ в&nbsp;медицине',
    nextProjectImg: '/images/pic/ck10/aimednext.png',
    nextProjectLink: '/cases/development/aimed',
    nextProjectLinkTitle: '',
    nextProjectText:
        'Разработали высоконагруженную платформу для конкурсов AI&rsquo;m Finder и&nbsp;AI&rsquo;m Doctor и&nbsp;сформировали уникальные датасеты для обучения российских ИИ-систем, которые станут основой системы поддержки принятия врачебных решений.',
};
const Sk10 = () => {
    return (
        <section>
            <TitleCase
                img="/images/pic/ck10/ck10.png"
                listPath={listPath}
                listTitle={listTitle}
                caseName="ck10"
            />
            <Target />
            <LayoutPage listStages={listStages} />
            <Solution
                list={listSolutions}
                listAudit={listResults}
                listMedia={listSolutionsMedia}
                listMediaParagraph={listSolutionsMediaParagraf}
                listParagraph={listSolutionsParagraf}
                listPage={listSolutionsPages}
                listAnalyse={listSolutionsAnaliz}
                listDifficulties={listSolutionsDifficulties}
            />
            <Media />
            <Testing />
            <Results list={listPageResults} />
            <Team />
            <NextProject NextProject={nextProjectdevRec} />
        </section>
    );
};

export default Sk10;
